/**
 * Размеры при черчении стены: от начала и конца черновика до соседних стен — те же синие
 * линии с длиной в плашке, что у проёма и у предметов по Ctrl. Что меряется — решает
 * `wallDrawClearances`. На лист PDF не попадают.
 */
import { ClearanceLine } from "@/widgets/layers";
import type { Clearance } from "@/widgets/plan";

export const DrawClearances2D = ({
	clearances,
	mmPerPx,
}: {
	clearances: Clearance[];
	mmPerPx: number;
}) => (
	<g data-plan-export-exclude style={{ pointerEvents: "none" }}>
		{clearances.map((clearance) => (
			<ClearanceLine
				key={`${Math.round(clearance.from.x)}:${Math.round(clearance.from.y)}:${Math.round(clearance.to.x)}:${Math.round(clearance.to.y)}`}
				clearance={clearance}
				mmPerPx={mmPerPx}
			/>
		))}
	</g>
);
